/* eslint-disable */

import axios from 'axios';

const baseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  state: {
    latestCourseState: {},
    courseByCategoryList: {},
    deleteCourseList: {},
    updateSectionIndex: {},
    sectionfileIndex: {},
    coursesList: {},
    updateCourseIndex: {},
    trashCourseState:{}
  },
  mutations: {
    getcourses(state, response) {
      state.latestCourseState = response;
    },
    trashCourses(state, response) {
      state.trashCourseState = response;
    },
    courseByCategoryMut(state, value) {
      state.courseByCategoryList = value;
    },
    deleteCourseMutation(state, value) {
      state.deleteCourseList = value;
    },
    sectionDragableMuation(state, value) {
      state.updateSectionIndex = value;
    },
    sectionfileDragableMuation(state, value) {
      state.sectionfileIndex = value;
    },
    GET_COURSE_LIST(state, value) {
      state.coursesList = value
    },
    UPDATE_COURSE_INDEX(state, value) {
      state.updateCourseIndex = value
    }
  },
  actions: {
    getcourselist(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get("courses/admin/course/").then((response) => {
            context.commit('getcourses', response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      })
    },
    trashCourselist(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get("courses/admin/course/?is_deleted=1").then((response) => {
            context.commit('trashCourses', response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      })
    },
    CourseByCategoryAction(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('courses/admin/course/?category=' + payload.id).then((response) => {
            // debugger
            if (response.status != '401' && response.status != '403') {
              context.commit('courseByCategoryMut', response.data.data)
            } else {
              router.push('/login')
            }
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    removeCourseFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('courses/admin/course/' + payload.id + '/').then((response) => {
            context.commit('deleteCourseMutation', response.data.data)
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    // Section File Index Update when drapable
    updateIndexDragSection(context, payload) {
      let url = baseURL + "courses/admin/course/section/";
      let id = payload.data.id;
      return new Promise((resolve, reject) => {
        axios.patch(url + id + '/' + 'index' + '/', payload.data.data).then((response) => {
            context.commit('sectionDragableMuation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    updateIndexDragSectionFile(context, payload) {
      let url = baseURL + "courses/admin/course/section/file/";
      let id = payload.data.id;
      return new Promise((resolve, reject) => {
        axios.patch(url + id + '/' + 'index' + '/', payload.data.data).then((response) => {
            context.commit('sectionfileDragableMuation', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    updateIndexDragAssignment(context, payload) {
      let url = baseURL + "/assignments/admin/assignment/";
      let id = payload.data.id;
      return new Promise((resolve, reject) => {
        axios.patch(url + id + '/' + 'index' + '/', payload.data.data).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    updateIndexDragAssignmentFile(context, payload) {
      let url = baseURL + "/assignments/admin/assignment/file/";
      let id = payload.data.id;
      return new Promise((resolve, reject) => {
        axios.patch(url + id + '/' + 'index' + '/', payload.data.data).then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
    getCourseCategoryId(context, payload) {
      let id = payload.categoryId;
      return new Promise((resolve, reject) => {
        axios.get("courses/admin/category/" + id + "/").then(function(response) {
            context.commit('GET_COURSE_LIST', response.data.data);
            resolve(response);
          })
          .catch(
            function(err) {
              reject(err);
            }
          )
      })
    },
    UpdateCourseIndex(context, payload) {
      let categoryId = payload.data.categoryId;
      let courseId = payload.data.courseId;
      let url = baseURL + "courses/admin/category/" + categoryId + "/course/" + courseId + "/index/";
      return new Promise((resolve, reject) => {
        axios.patch(url, payload.data.data).then((response) => {
            context.commit('UPDATE_COURSE_INDEX', response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
      })
    },
  },
  getters: {
    getlastestCoursesState: state => state.latestCourseState,
    trashCoursesState: state => state.trashCourseState,
    getCourseByCategoryState: state => state.courseByCategoryList,
    deleteCourseState: state => state.deleteCourseList,
    updateSectionIndexState: state => state.updateSectionIndex,
    sectionfileIndexState: state => state.sectionfileIndexState,
    getCourseListState: state => state.coursesList,
  }
}